import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {SubscriptionI} from '../models/subscription-i';

export const mySubscriptionsActionTypes = {
  LOAD: type('[My Subscriptions] Load'),
  LOAD_SUCCESS: type('[My Subscriptions] Load Success'),
  LOAD_FAIL: type('[My Subscriptions] Load Fail')
};

export class LoadMySubscriptionsAction implements Action {
  readonly type = mySubscriptionsActionTypes.LOAD;
  constructor(public payload?: string) {}
}

export class LoadMySubscriptionsSuccessAction implements Action {
  readonly type = mySubscriptionsActionTypes.LOAD_SUCCESS;
  constructor(public payload?: SubscriptionI[]) {}
}

export class LoadMySubscriptionsFailAction implements Action {
  readonly type = mySubscriptionsActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
